import {
  makeAutoObservable,
  reaction,
  runInAction,
  observable,
  observe,
  autorun,
} from "mobx";
import { commonAxios } from "../../CommonAxios";
import { showAlertToast } from "../../../../Components/ToastComponent/AlertMessage";
export class FieldMapperStore {
  recordType = "All Records";
  searchQuery = "";
  listOfAllGroups = [];
  rowLimitError = "";
  activeMode = "";
  selectedFields = new Map(); // key: group.value, value: Set of selected field values
  listOfAllFields = [];
  basicAdvnaceFields = new Map();
  commonMapper = observable.map();
  rowLimitRanges = {
    fromRange: 1,
    toRange: 10,
  };
  totalCredit = 0;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    this.commonMapper = observable.map({
      advancedFields: [],
      basicFields: [],
      activeTab: "",
      noOfContact: 1,
    });
    const disposer = observe(this.commonMapper, (change) => {
      switch (change.type) {
        case "add":
          break;
        case "update":
          if (
            change.name === "activeTab" &&
            change.oldValue !== change.newValue
          ) {
            this.selectedFields.clear();
            this.activeMode = "";
            // this.getEnrichmentFieldApi(change.newValue);
          }
          break;
        case "delete":
          break;
      }
    });
  }
  setRange(name, value) {
    this.rowLimitRanges[name] = value;
  }
  get getbasicFields() {
    return this.commonMapper.get("basicFields");
  }
  get getadvancedFields() {
    return this.commonMapper.get("advancedFields");
  }
  get getActiveTab() {
    return this.commonMapper.get("activeTab") || null;
  }
  get getNoOfContact() {
    return this.commonMapper.get("noOfContact");
  }
  get gettotalCredits() {
    return this.totalCredit;
  }
  settotalcredits = (credits) => {
    runInAction(() => {
      this.totalCredit = credits;
    })
  }
  clearselectedvalue = () => {
    runInAction(() => {
      this.selectedFields.clear();
      this.applyTheValue({ noOfContact: 1 });
      const store = this.rootStore.getDynamicDropDown("ContactJobTitle");
      store.clearMe();
      this.setRange("fromRange", 1);
      this.setRange("toRange", 10);
      this.totalCredit = 0;
    });
  };
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonMapper.set(key, value);
      }
    });
  }
  setSearchQuery(query) {
    runInAction(() => {
      this.searchQuery = query;
    });
  }
  // setRowLimitRange(name, value) {
  //   runInAction(() => {
  //     this.rowLimitRanges[name] = value;
  //   });
  // }

  setRowLimitRange = (name, value) => {
    const numericValue = Number(value);

    // Allow only digits and values ≥ 1
    if (!/^\d*$/.test(value)) return;
    if (numericValue < 1 && value !== "") return;

    this.rowLimitRanges[name] = value;

    const from = Number(this.rowLimitRanges.fromRange);
    const to = Number(this.rowLimitRanges.toRange);

    if (from && to) {
      if (from > to) {
        this.rowLimitError = `From range must be less than or equal to To range.`;
        showAlertToast({
          type: "warning",
          title: `Note`,
          message: "From range must be less than or equal to To range",
        });
      } else {
        this.rowLimitError = "";
      }
    } else {
      this.rowLimitError = "";
    }
  };
  setRecordType = (type) => {
    runInAction(() => {
      this.recordType = type;
    });
  };
  setNoOfContect = (count) => {
    runInAction(() => {
      this.noOfContact = count;
    });
  };
  setActiveMode = (mode) => {
    const isTurningOff = this.activeMode.includes(mode);
    // Flip the mode in the activeMode array
    if (isTurningOff) {
      this.activeMode = this.activeMode.filter((m) => m !== mode);
    } else {
      this.activeMode = [...this.activeMode, mode];
    }
    // Determine which list of values to operate on
    const fieldValues =
      mode === "BASIC" ? this.getbasicFields : this.getadvancedFields;
    // For each value in that mode:
    fieldValues.forEach((value) => {
      // Find the actual Field object
      const fieldObj = this.listOfAllFields.find((f) => f.value === value);
      if (!fieldObj) return;
      // const isSelected = this.selectedFields.includes(fieldObj);
      const isSelected = this.selectedFields.has(fieldObj);
      // If we’re turning OFF the mode, then remove any that are selected.
      // If we’re turning ON the mode, then add any that aren’t selected.
      if (isTurningOff && isSelected) {
        this.toggleFieldSelection(fieldObj);
      } else if (!isTurningOff && !isSelected) {
        this.toggleFieldSelection(fieldObj);
      }
    });
  };
  // toggleFieldSelection = (field) => {
  //   if (this.selectedFields.includes(field)) {
  //     this.selectedFields = this.selectedFields.filter((f) => f !== field);
  //   } else {
  //     this.selectedFields.push(field);
  //   }
  // };
  toggleFieldSelection = (fieldOrGroup, e) => {
    const temp = this.gettotalCredits;
    runInAction(() => {
      const isGroup = Array.isArray(fieldOrGroup.fields);
      const groupKey = isGroup ? fieldOrGroup.value : fieldOrGroup.groupValue;
      const fieldValue = fieldOrGroup.value;
      let groupFields = this.selectedFields.get(groupKey) || new Set();
      if (isGroup) {
        const fullGroup = this.fieldGroups.find(g => g.value === groupKey);
        const allFieldValues = fullGroup.fields.map(f => f.value);
        const isFullySelected =
          this.selectedFields.has(groupKey) &&
          groupFields.size === fullGroup.fields.length;
        if (isFullySelected) {
          this.selectedFields.delete(groupKey);
          this.settotalcredits(temp - fieldOrGroup.price);
        } else {
          this.selectedFields.set(groupKey, new Set(allFieldValues));
          if (!this.selectedFields.has(groupKey) || groupFields.size === 0) {
            this.settotalcredits(temp + fieldOrGroup.price);
          }
        }
      } else {
        // Toggle individual field
        if (groupFields.has(fieldValue)) {
          groupFields.delete(fieldValue);
        } else {
          groupFields.add(fieldValue);
        }
        if (groupFields.size > 0) {
          this.selectedFields.set(groupKey, groupFields);
        } else {
          this.selectedFields.delete(groupKey);
        }
        const fullGroup = this.fieldGroups.find(g => g.value === groupKey);
        const isFullySelected =
          fullGroup && groupFields.size === fullGroup.fields.length;
        // Automatically convert to full group selection if all are selected
        if (isFullySelected) {
          this.selectedFields.set(groupKey, new Set(fullGroup.fields.map(f => f.value)));
        }
        if (groupFields.size === 1) {
          this.settotalcredits(temp + fieldOrGroup.price);
        }
        if (groupFields.size === 0) {
          this.settotalcredits(temp - fieldOrGroup.price);
        }
      }
    });
  };
  isFieldSelected = (groupKey, fieldValue) => {
    return (
      this.selectedFields.has(groupKey) &&
      this.selectedFields.get(groupKey).has(fieldValue)
    );
  };
  isGroupSelected = (group) => {
    const selected = this.selectedFields.get(group.value);
    return selected?.size === group.fields.length;
  };
  // get filteredFields() {
  //   return this.listOfAllFields.filter((field) =>
  //     field.label.toLowerCase().includes(this.searchQuery.toLowerCase())
  //   );
  // }
  // getEnrichmentFieldApi = async (value) => {
  //   const type =
  //     value === "company" ? "business" : value === "people" ? "contact" : "";
  //   try {
  //     // runInAction(() => {
  //     //   this.rootStore.callCommonLoader(true);
  //     // });
  //     const res = await commonAxios(
  //       `/getEnrichKeywords?type=${type}`,
  //       "GET",
  //       {},
  //       {}
  //     );
  //     runInAction(() => {
  //       if (res?.data) {
  //         this.listOfAllFields = res.data.list ?? [];
  //         // this.rootStore.callCommonLoader(false);
  //         // Accessing basic and advanced fields correctly
  //         const updates = {
  //           basicFields: res?.data?.basic || [], // 'basic' is the correct field name
  //           advancedFields: res?.data?.advanced || [], // 'advanced' is the correct field name
  //         };
  //         this.applyTheValue(updates);
  //       } else {
  //         this.basicFields = [];
  //         this.advancedFields = [];
  //         // this.rootStore.callCommonLoader(false);
  //       }
  //     });
  //   } catch (error) {
  //     // this.rootStore.callCommonLoader(false);
  //   }
  // };
  get fieldGroups() {
    // If there's no searchQuery, return all groups
    if (!this.searchQuery) return this.listOfAllGroups;
    const query = this.searchQuery.toLowerCase();
    // Filter by group label or group value, or by field label inside group
    return (
      this.listOfAllGroups
        .map((group) => {
          // If group label or value matches, include all fields
          if (
            (group.label && group.label.toLowerCase().includes(query)) ||
            (group.value && group.value.toLowerCase().includes(query))
          ) {
            return group;
          }
          // Otherwise, filter fields within the group
          const filteredFields = (group.fields || []).filter((field) =>
            field.label.toLowerCase().includes(query)
          );
          return {
            ...group,
            fields: filteredFields,
          };
        })
        // Only include groups that have at least one field after filtering
        .filter(
          (group) => Array.isArray(group.fields) && group.fields.length > 0
        )
    );
  }
  getEnrichmentFieldApi = async (value) => {
    const type =
      value === "company" ? "business" : value === "people" ? "contact" : "";
    this.rootStore.callCommonLoader(true)
    try {
      const res = await commonAxios(
        `/getEnrichKeywords?type=${type}`,
        "GET",
        {},
        {}
      );
      runInAction(() => {
        if (res?.data) {
          this.listOfAllGroups = res.data.groupByFields ?? [];
          this.listOfAllFields = res.data.groupByFields.flatMap(
            (group) => group.fields ?? []
          );
          const updates = {
            basicFields: res?.data?.basic || [],
            advancedFields: res?.data?.advanced || [],
          };
          this.applyTheValue(updates);
          this.rootStore.callCommonLoader(false)
        } else {
          this.listOfAllGroups = [];
          this.listOfAllFields = []; // Optional fallback
        }
      });
    } catch (error) {
      this.rootStore.callCommonLoader(false)
    }
  };
  enrichementApiCall = async (userId, tableId, apiUrl, type, fromrange, torange, loader = true) => {
    try {
      {
        loader === true && (
          runInAction(() => {
            this.rootStore.callCommonLoader(true);
          })
        )
      }
      const selectedvalueString =
        this.selectedFields.size > 0
          ? Array.from(this.selectedFields.keys()).join(",")
          : "";
      const customFieldsString = Array.from(this.selectedFields.values())
        .flatMap(set => Array.from(set))
        .join(',');
      const keyValueObject = Object.fromEntries(
        Array.from(this.selectedFields.entries()).map(([key, valueSet]) => [
          key,
          Array.from(valueSet),
        ])
      );
      const response = await commonAxios(
        apiUrl,
        "POST",
        {},
        {
          tableId: tableId,
          userId: userId,
          fields: selectedvalueString,
          customFields: customFieldsString,
          rowIds: "all",
          startRange: type === "contact" ? fromrange : this.rowLimitRanges.fromRange,
          endRange: type === "contact" ? torange : this.rowLimitRanges.toRange,
          fieldsInfo: keyValueObject
        }
      );
      if (response) {
        runInAction(() => {
          this.rootStore.applyTheValue({ showModalEnrichment: false });
          if (this.rootStore.gridStore.tabIndex === 1) {
            localStorage.setItem("searchPeopleInfo", JSON.stringify(true));
          }
          if (this.rootStore.gridStore.tabIndex === 0) {
            localStorage.setItem("searchCompanyInfo", JSON.stringify(true));
          }
          {
            loader === true && (
              this.rootStore.callCommonLoader(false)
            )
          }
          this.clearselectedvalue();
          // localStorage.setItem("searchCompanyInfo", JSON.stringify(true));
          this.rootStore.getUserCredits();
        });
      }
    } catch (error) {
      runInAction(() => {
        this.rootStore.callCommonLoader(false);
      });
      showAlertToast({
        type: "warning",
        title: `Note`,
        message: error?.response?.data?.error?.message,
      });
      this.clearselectedvalue();
    }
  };
  peopleEnrichment = async (userId, tableId) => {
    try {
      this.rootStore.callCommonLoader(true);
      const store = this.rootStore.dynamicFlags.get("ContactJobTitle"); // get the MultiSelectStore
      const selectedValues = store?.selectedValues || [];
      // get selectedValues safely
      const jobGroup = Array.from(selectedValues)
        .map((item) => item.value) // assuming each selected item has a `value` property
        .join(",");
      const fields = Array.from(this.selectedFields)
        .map((item) => item.value)
        .join(",");
      if (!jobGroup || !fields) {
        showAlertToast({
          type: "warning",
          title: "Missing Required Fields",
          message: !jobGroup
            ? "Please select at least one job title before enrichment."
            : "Please select at least one field before enrichment.",
        });
        this.rootStore.callCommonLoader(false);
        return;
      }
      const response = await commonAxios(
        "/enrich/people",
        "POST",
        {},
        {
          tableId: tableId,
          userId: userId,
          fields: Array.from(this.selectedFields)
            .map((item) => item.value)
            .join(","),
          rowIds: "all",
          jobGroup: jobGroup,
          // jobGroup: "Director",
          noOfContact: this.getNoOfContact,
          startRange: this.rowLimitRanges.fromRange,
          endRange: this.rowLimitRanges.toRange,
        }
      );
      if (response) {
        runInAction(() => {
          this.rootStore.applyTheValue({ showModalEnrichment: false });
          this.rootStore.callCommonLoader(false);
          this.clearselectedvalue();
          this.rootStore.taskStore.settabIndex(0);
        });
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error?.message;
      this.rootStore.callCommonLoader(false);
      showAlertToast({
        type: "error",
        title: "Something went wrong",
        message: errorMessage || "An unexpected error occurred",
      });
    }
  };
}
